import { CustomRouteParams, ExtraParameters } from './type.gen'
import { Widget, routerSwitch, route, notFoundRouteCase, Route } from 'widgets-for-react'

export let router = <a, b extends { kind: keyof a }>(
  custom_routes: Route<CustomRouteParams<a, b>>[],
  rootpath: string,
  rootpath_to_ignore: string
): Widget<CustomRouteParams<a, b>> =>
  routerSwitch<CustomRouteParams<a, b>>({ key: `router-switch` })([
    route<{}, CustomRouteParams<a, b>>(rootpath_to_ignore + '/*', _ => ({ kind: 'ignore' })),
    route<{}, CustomRouteParams<a, b>>(rootpath_to_ignore + '/', _ => ({ kind: 'ignore' })),
    //other cases?
    ...custom_routes,
    route<{ slug?: string, queryParams?:string }, CustomRouteParams<a, b>>(rootpath + '/:slug*', a => {
      let queryParamsParsed : ExtraParameters = []
      if(a.queryParams && a.queryParams != ""){
        a.queryParams.split(";").forEach(ps => {
          let current_param_group:{param:string, value:string}[] = []
          ps.split("!").forEach(p => {
            let current_param = p.split("$")
            if(current_param.length == 2){
              current_param_group.push({param:current_param[0], value:current_param[1]})
            }
          })
          queryParamsParsed.push(current_param_group)
        })
      }
      //example 1: http://localhost:5000/sample-page/?queryParams=kind$map!city$rotterdam!view$list
      //example 2: http://localhost:5000/?queryParams=kind$map!city$rotterdam!view$list&slug=sample-page
      return { kind: 'page', slug: a.slug, extra_params:queryParamsParsed.length > 0 ? queryParamsParsed : undefined }
    }),
    notFoundRouteCase<CustomRouteParams<a, b>>(() => ({ kind: '404' }))
  ])
  